import React, {Component} from 'react';
import {connect} from 'react-redux';

import {
    Container,
    Nav,
    Navbar, Row
} from 'reactstrap';

import UserBubble from '../../../components/user/UserBubble';
import CircleButton from '../../../components/controls/buttons/CircleButton';
import ManageGroupDialog from './ManageGroupDialog';
import TenantInterestList from './TenantInterestList';
import TenantApplicationStatus from './TenantApplicationStatus';
import TenantGroupListingModule from './TenantGroupListingModule';
import TenantNotifications from './TenantNotifications';
import TenantRecommendedListings from './TenantRecommendedListings';
import PolyUtil from "../../../util/PolyUtil";
import Loader from "../../../components/display/Loader";
import ReduxModalWrapper from "../../../components/display/Modals/ReduxModalWrapper";
import {displayModal, hideModal} from "../../../store/actions/display";
import DashboardPlaceholder from "../../../components/dashboard/DashboardPlaceholder";
import {Link} from "react-router";

class TenantDashboard extends Component {
    state = {
        showManageGroupModal: false,
        test: false
    };

    toggleManageGroupModal = () => {
        // this.setState({showManageGroupModal: !this.state.showManageGroupModal});
        this.props._displayModal({
            id: "manage_group_modal",
            header: "Manage your Group",
            body: (<ManageGroupDialog/>)
        });
    };

    dashboardElementsReady = () => {
        const {invitations, applied_listings, interest_list, recommended_listings} = this.props.dashboardElements;

        return (
            invitations !== null
            && applied_listings !== null
            && interest_list !== null
            && recommended_listings !== null
        );
    };

    dashboardElementsPopulated = () => {
        const {invitations, percent_complete, applied_listings, interest_list, recommended_listings} = this.props.dashboardElements;
        return this.dashboardElementsReady() && (
            invitations.length > 0
            || percent_complete !== 100
            || applied_listings.length > 0
            || interest_list.length > 0
            || recommended_listings.length > 0
        );
    };

    render() {
        const {roommates} = this.props;

        const placeholderBody = (
            <div>
                <p className="text-center">
                    It looks like we couldn't find anything to put here, but there's a few easy fixes! You could try making
                    your <strong><Link to="/settings">listing recommendation preferences</Link></strong> less strict, or you could head over to <strong><Link to="/explore">explore</Link></strong> and
                    apply to a listing or two!
                </p>
                <p className="text-center">
                    We hope you the best in your rental journey!
                </p>
            </div>
        );
        return (
            <Loader spin isLoading={!PolyUtil.validArr(roommates) && this.dashboardElementsReady()}>
                <Navbar style={{backgroundColor: '#374245'}} className="horizontal-scroll">
                    <Nav className="mx-auto py-1" navbar>
                        <Container>
                            <Row className="d-flex justify-content-center flex-nowrap">
                                {
                                    roommates && roommates.map(function (roommate, i) {
                                        let color;

                                        if (roommate.application_percent_complete === 0 && !roommate.is_payment_method_on_file) color = 'text-danger';
                                        else if (roommate.application_percent_complete === 100 && roommate.is_payment_method_on_file) color = 'text-success';
                                        else color = 'text-warning';

                                        let appColor = roommate.application_percent_complete === 0 ? 'text-danger' : roommate.application_percent_complete === 100 ? 'text-success' : 'text-warning';

                                        let paymentColor = roommate.is_payment_method_on_file ? 'text-success'
                                            : 'text-danger';

                                        // let color = roommate.application_percent_complete === 0 ? 'danger' : roommate.application_percent_complete === 100 ? 'success' : 'warning';
                                        return (
                                            <UserBubble color={color.split('-')[1]}
                                                        key={i}
                                                        label={roommate.get_first_name}
                                                        initials={roommate.get_first_name.charAt(0) + "" + roommate.get_last_name.charAt(0)}
                                                        highlight={roommate.is_coordinator}
                                                        popover={{
                                                            title: "Status:",
                                                            content: (
                                                                <div>
                                                                    {
                                                                        roommate.is_coordinator && (
                                                                            <div>
                                                                                <span className="text-warning"><i className="fa fa-star"/> Group Coordinator</span>
                                                                            </div>
                                                                        )
                                                                    }
                                                                    <strong>Application:</strong>
                                                                    <div className={appColor}>
                                                                        {
                                                                            roommate.application_percent_complete === 0
                                                                                ? 'Not started' : roommate.application_percent_complete === 100
                                                                                ? 'Complete' : 'In progress'
                                                                        }
                                                                    </div>
                                                                    <br/>
                                                                    <strong>Payment:</strong>
                                                                    <div className={paymentColor}>
                                                                        {
                                                                            roommate.is_payment_method_on_file ? "All set!" : "No payment method"
                                                                        }
                                                                    </div>
                                                                </div>
                                                            )
                                                        }}/>
                                        );
                                    })
                                }
                                <CircleButton onClick={this.toggleManageGroupModal}>
                                    <i className={roommates.length === 1 ? 'fa fa-plus' : 'fa fa-cog'}/>&nbsp;{roommates.length === 1 ? 'Add Roommates' : 'Manage Roommates'}
                                </CircleButton>

                            </Row>
                        </Container>
                    </Nav>
                </Navbar>

                <Container style={{marginBottom: '3em'}}>
                    {
                        this.dashboardElementsPopulated() ? (
                            <div>
                                <TenantNotifications/>
                                <TenantApplicationStatus/>
                                <TenantGroupListingModule/>
                                <TenantInterestList/>
                                <TenantRecommendedListings/>
                            </div>
                        ) : (
                            <div className="d-flex justify-content-center mt-3">
                                <DashboardPlaceholder title="Wow, there's nothing here!" body={placeholderBody}/>
                            </div>
                        )
                    }
                </Container>
                <ReduxModalWrapper id="manage_group_modal"/>
            </Loader>
        );
    }
}

const mapStateToProps = (state) => ({
    first_name: state.activeUser.first_name,
    last_name: state.activeUser.last_name,
    roommates: state.tenant.roommate_group.roommates,
    is_coordinator: state.tenant.roommate_group.coordinator && state.activeUser.email === state.tenant.roommate_group.coordinator.get_email,

    dashboardElements: {
        invitations: state.tenant.invitations,
        percent_complete: state.tenant.application.application_percent_complete,
        applied_listings: state.tenant.roommate_group.applied_listings,
        interest_list: state.tenant.interest_list,
        recommended_listings: state.tenant.recommended_listings
    }
});

const mapDispatchToProps = (dispatch) => ({
    _displayModal(modalData) {
        return dispatch(displayModal(modalData));
    },
    _hideModal(id) {
        return dispatch(hideModal(id));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(TenantDashboard);



// WEBPACK FOOTER //
// ./src/containers/tenant/dashboard/TenantDashboard.js